import React, { Component } from "react";
import FeaturedContentShimmer from "../shimmer/featuredContentShimmer";
import withShimmer from "../shimmer/withShimmer";
import LoadingStatus from "../../constants/loadingStatus";
import contentItems from "../../constants/videos-data.json";
import VideoCard from "./videoCard";
import "./videoList.scss";

class VideoList extends Component {
  constructor(props) {
    super(props);

    this.generateCards = () =>
      contentItems &&
      contentItems.map((item) => <VideoCard key={item.id} video={item} />);
  }

  render() {
    return (
      <div className="container">
        <div className="learn-video-list row">
          {withShimmer(
            this.generateCards(),
            FeaturedContentShimmer,
            LoadingStatus.loaded
          )}
        </div>
      </div>
    );
  }
}

export default VideoList;
